import { AppConfigurationTab, Translation } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getAppConfigurationTabs = (): TabItem[] =>
  [
    {
      key: AppConfigurationTab.CONFIGURATION,
      name: i18n.t(`${Translation.Configuration}:tabs.appConfiguration.appConfiguration`),
    },
  ] as const;
